import React from 'react';
import {get as _get} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {refetchQueryByName} from '@utils/apollo';
import {IconInfoCircle} from '@appComponents/IconCollection';
import {CLIENT_BOOKING_BULK_PACKAGE_UPDATE_MSG} from '@modules/client/constants/messages';
import {handleBulkBookingsError} from '@modules/client/utils/clientBookingsHelper';
import {hideModal} from '@utils/modal';

export default class ClientBookingsBulkChangeForm extends DefaultForm {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            clientPackages: [],
            invoiceStatuses: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();

        this.setOptionParsers({
            invoice_status: (data) => [
                {key: 'inherited', value: 'inherited', text: 'Inherited from event report'},
                ...data.map(is => ({key: is.id, value: is.id, text: is.name})),
            ],
        });

        this.setCreateSuccessCallback(() => {
            refetchQueryByName(this.props.formParams.queryForRefetch);
        });

        this.setCreateErrorCallback((error) => {
            hideModal();
            handleBulkBookingsError(error);
        });

        this.setOnChangeCallback({
            price_edit_options: (data) => {
                const showPrice = 'modify_price' === data.value;
                const updateBasedOnClientPackage = 'update_based_on_client_package' === data.value;

                this.setField('price', {
                    hidden: !showPrice,
                    defaultValue: !showPrice ? null : '',
                });

                this.setField('separator', {
                    hidden: !showPrice,
                });

                this.setField('price_edit_options', {
                    description: updateBasedOnClientPackage ? <IconInfoCircle tooltip={CLIENT_BOOKING_BULK_PACKAGE_UPDATE_MSG}/> : null,
                });
            },
            client_package: (data) => {
                if (!data.value) {
                    this.setField('price_edit_options', {
                        defaultValue: 'keep_price',
                    });

                    if (!_get(this.state, 'defaultForm_fields.price.props.hidden')
                        || !_get(this.state, 'defaultForm_fields.separator.props.hidden')) {
                        this.setField('price', {
                            hidden: true,
                            defaultValue: null,
                        });

                        this.setField('separator', {
                            hidden: true,
                        });
                    }
                }
            },
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (this.state.clientPackages !== this.props.clientPackages) {
            this.setField('client_package', {
                options: this.props.clientPackages,
            });
            this.setState({ clientPackages: this.props.clientPackages });
        }

        if (this.state.invoiceStatuses !== this.props.invoiceStatuses) {
            this.setField('invoice_status', {
                options: this.props.invoiceStatuses,
            });
            this.setState({ invoiceStatuses: this.props.invoiceStatuses });
        }
    }

    prepareDataForSubmit(data) {
        const dataForSubmit = super.prepareDataForSubmit(data).ClientBookingsBulkChange;

        return {
            ...dataForSubmit,
            client: this.props.formParams.client,
            is_common_product: this.props.formParams.isCommonProduct,
            price: null === dataForSubmit.price ? null : parseFloat(dataForSubmit.price),
            invoice_status: 'inherited' === dataForSubmit.invoice_status ? null : dataForSubmit.invoice_status,
            booking_details: this.props.formParams.bookingDetails,
            keep_existing_price: 'keep_price' === data.price_edit_options,
            update_based_on_client_package: 'update_based_on_client_package' === data.price_edit_options,
        };
    }
}
